export enum RoleEnum {
  FRIEND = 1,
  LOVER = 2,
  DERMO = 3,
  PREGNANCY = 4,
}
